import AlarmBellIcon from '../../assets/icons/alarm-bell.svg?react';
import { AlarmTriggerState } from '../../gql/generated';
import { cn } from '../../utils/className';

export interface NotificationStateIconProps {
  state: AlarmTriggerState;
  className?: string;
}

/**
 * Leading bell icon shown per notification row: red for a trigger event,
 * muted grey for a resolve event.
 */
export function NotificationStateIcon({
  state,
  className,
}: NotificationStateIconProps) {
  const isTrigger = state === AlarmTriggerState.Triggered;

  return (
    <AlarmBellIcon
      className={cn(
        'h-3.5 w-3.5 shrink-0',
        isTrigger ? 'text-negative' : 'text-disabled',
        className
      )}
      aria-label={isTrigger ? 'Triggered' : 'Resolved'}
    />
  );
}
